import React from "react";

function SettingsThree() {
  return <div>SettingsThree</div>;
}

export default SettingsThree;
